<div class="modal-container">
  <div>
    <p mat-dialog-title>{{ data.title }}</p>
    @if (data.subtitle) {
      <mat-dialog-content>{{ data.subtitle }}</mat-dialog-content>
    }
  </div>
  @if (data.message) {
    <mat-dialog-content>{{ data.message }}</mat-dialog-content>
  }
  <mat-dialog-actions [class]="data.buttons?.length === 1 ? 'single-button-area' : 'multiple-buttons-area'">
    @for (btn of data.buttons; track $index) {
      <button mat-raised-button [color]="btn.color" (click)="onButtonClick(btn)">{{ btn.text }}</button>
    }
  </mat-dialog-actions>

  <div class="multiple-buttons-area"></div>
</div>
